<template>
  <!-- Lagerplatz-Feld (WMS mobil): tippen filtert die erlaubten Plaetze, Scan fuellt vor.
       Die Liste kommt von /warehouses/storage_locations - der Server erzwingt die
       Lager-Zuordnung des Benutzers, fremde Plaetze tauchen gar nicht erst auf. -->
  <div>
    <div class="m-wms-form__row">
      <div class="m-wms-form__field">
        <label>{{ label }} *</label>
        <input v-model="query" :placeholder="$t('mobile.wms.locationPlaceholder')" @input="onInput" @focus="onInput" />
      </div>
      <m-wms-photo-button kind="location" @extracted="onPhotoResult" @extract-error="scanError = $t('mobile.wms.photoReadError')" />
      <button type="button" class="m-wms-form__iconbtn" @click="scannerOpen = true"><i class="material-icons">qr_code_scanner</i></button>
    </div>
    <ul v-if="suggestions.length" class="m-wms-suggest">
      <li v-for="s in suggestions" :key="s.id" @click="choose(s)">{{ s.fullName }}</li>
    </ul>
    <p v-if="scanError" class="m-wms-form__error">{{ scanError }}</p>

    <m-barcode-scanner v-if="scannerOpen" @scanned="onScanned" @close="scannerOpen = false" />
  </div>
</template>

<script>
import WarehouseService from "@/services/warehouse.service";
import MBarcodeScanner from "../components/MBarcodeScanner.vue";
import MWmsPhotoButton from "./MWmsPhotoButton.vue";

export default {
  name: "MWmsLocationField",
  components: { MBarcodeScanner, MWmsPhotoButton },
  props: {
    label: { type: String, required: true },
    value: { type: Object, default: null }, // { id, fullName }
  },
  data() {
    return { query: "", locations: [], suggestions: [], scannerOpen: false, scanError: null };
  },
  async created() {
    // Einmal laden, dann lokal filtern (Lager-WLAN) - nur aktive Plaetze, Server filtert das Lager
    const list = await WarehouseService.getLocationsByWarehouse({ warehouseId: 0, location: "", isPulldown: true });
    this.locations = (list || []).filter((l) => l.isActive);
  },
  methods: {
    onInput() {
      this.scanError = null;
      this.$emit("input", null);
      const q = this.query.trim().toUpperCase();
      this.suggestions = q.length < 2 ? [] : this.locations.filter((l) => (l.fullName || "").toUpperCase().includes(q)).slice(0, 12);
    },
    choose(loc) {
      this.query = loc.fullName;
      this.suggestions = [];
      this.$emit("input", { id: loc.id, fullName: loc.fullName });
    },
    onPhotoResult(r) {
      // Server hat Format und Existenz schon geprueft - hier bleibt nur der Abgleich mit der
      // rechte-gefilterten Liste (fremde Lager tauchen dort nicht auf)
      this.scanError = null;
      const code = r && (r.location || r.locationRaw);
      const hit = r && r.locationKnown && r.location ? this.locations.find((l) => (l.fullName || "").toUpperCase() === r.location) : null;
      if (hit) {
        this.choose(hit);
        this.query = hit.fullName;
      } else if (code) {
        this.scanError = this.$t("mobile.wms.locationScanUnknown", { code });
      } else {
        this.scanError = this.$t("mobile.wms.photoReadFailed");
      }
    },
    onScanned({ value }) {
      this.scannerOpen = false;
      this.scanError = null;
      const code = String(value || "")
        .trim()
        .toUpperCase();
      // Gleiche Formatregel wie im Retouren-Workflow: Lagercode + drei zweistellige Gruppen
      if (!/^(PP|WI)-\d{2}-\d{2}-\d{2}$/.test(code)) {
        this.scanError = this.$t("mobile.wms.locationScanInvalid", { code });
        return;
      }
      const hit = this.locations.find((l) => (l.fullName || "").toUpperCase() === code);
      if (!hit) {
        this.scanError = this.$t("mobile.wms.locationScanUnknown", { code });
        return;
      }
      this.choose(hit);
    },
  },
};
</script>

<style lang="scss" scoped src="./m-wms.scss"></style>
